(() => {
  'use strict';
  const configElement = document.getElementById('WalzConfiguration');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const strings = config.strings;
  const dialog = document.getElementById('WalzDialog');
  const content = dialog.querySelector('[data-walz-content]');
  let opener;
  let trailTerrain = '';
  let liveConcierge = null;
  const root = config.rootUrl.replace(/\/$/, '');
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };
  const say = (text, className = '') => content.append(element('p', `assistant-message ${className}`, text));
  const choice = (text, callback) => {
    const button = element('button', 'assistant-choice', text);
    button.type = 'button';
    button.addEventListener('click', callback);
    content.append(button);
  };
  const link = (text, path) => {
    const anchor = element('a', 'button button-pine assistant-link', `${text} ↗`);
    anchor.href = path;
    content.append(anchor);
  };
  const clear = () => { content.replaceChildren(); };
  const focusContent = () => {
    const node = content.querySelector('button, a');
    if (node) node.focus({ preventScroll: true });
  };
  function showTrail() {
    clear();
    say(strings.trailTerrain);
    [strings.terrainMountain, strings.terrainForest].forEach(terrain => choice(terrain, () => {
      trailTerrain = terrain;
      clear();
      say(terrain, 'assistant-user-choice');
      say(strings.trailComfort);
      [strings.comfortCushion, strings.comfortPrecision].forEach(comfort => choice(comfort, () => {
        clear();
        say(`${trailTerrain} · ${comfort}`, 'assistant-user-choice');
        say(strings.trailResult);
        say(strings.fitNote, 'assistant-caution');
        link(strings.viewTrail, config.links.trail);
        focusContent();
      }));
      focusContent();
    }));
  }
  function showSkiSources(isRace, isTransitions) {
    if (!isRace && !isTransitions) return;
    const details = element('details', 'assistant-sources');
    details.append(element('summary', '', strings.skiSources));
    const addSource = (label, url) => {
      const anchor = element('a', '', label);
      anchor.href = url;
      anchor.target = '_blank';
      anchor.rel = 'noopener noreferrer';
      details.append(anchor);
    };
    if (isRace) {
      addSource(strings.sourcePierra, 'https://www.pierramenta.com/coureurs.html');
      addSource(strings.sourceMezzalama, 'https://www.trofeomezzalama.it/docs/2025/REGTrofeoMezzalama_EN2025.pdf');
      details.append(element('p', '', strings.sourceRulesNote));
    }
    if (isTransitions) addSource(strings.sourcePomoca, 'https://www.pomoca.com/blog/pomoca-user-guide');
    content.append(details);
  }
  function showSki() {
    clear();
    say(strings.skiGoal);
    [false, true].forEach(isRace => {
      const goal = isRace ? strings.skiTeamRace : strings.skiFirstTours;
      choice(goal, () => {
        clear();
        say(goal, 'assistant-user-choice');
        say(strings.skiPriority);
        [false, true].forEach(isTransitions => {
          const priority = isTransitions ? strings.skiTransitions : strings.skiSystem;
          choice(priority, () => {
            clear();
            say(`${goal} · ${priority}`, 'assistant-user-choice');
            if (isRace) say(strings.skiRaceIntro);
            say(isTransitions ? strings.skiTransitionAdvice : strings.skiResult);
            if (isRace && !isTransitions) say(strings.skiRaceProduct);
            say(strings.skiNote, 'assistant-caution');
            if (isRace && !isTransitions) link(strings.viewSki, config.links.ski);
            else link(strings.viewCatalog, config.links.catalog);
            showSkiSources(isRace, isTransitions);
            focusContent();
          });
        });
        focusContent();
      });
    });
  }
  function showRange() {
    clear();
    say(strings.rangeResult);
    say(strings.rangeNote, 'assistant-caution');
    link(strings.viewCatalog, config.links.catalog);
  }
  function showWelcome(context = {}) {
    clear();
    say(context.productHandle ? strings.productContext : strings.welcome);
    say(strings.choose, 'assistant-muted');
    choice(strings.trail, () => { showTrail(); focusContent(); });
    choice(strings.ski, () => { showSki(); focusContent(); });
    choice(strings.range, () => { showRange(); focusContent(); });
  }
  function openPreview(context = {}) {
    liveConcierge?.pause();
    opener = document.activeElement;
    if (context.intent === 'trail') showTrail();
    else if (context.intent === 'ski') showSki();
    else if (context.intent === 'range') showRange();
    else showWelcome(context);
    if (!dialog.open) dialog.showModal();
  }
  if (window.WalzLive?.create) liveConcierge = window.WalzLive.create({ config, dialog, content, element, openPreview });
  const existingWalz = window.Walz || {};
  window.Walz = {
    ...existingWalz,
    open: existingWalz.open || function(context = {}) {
      const event = new CustomEvent('walz:open', { detail: context, cancelable: true });
      const shouldFallback = window.dispatchEvent(event);
      if (config.mode === 'live') {
        opener = document.activeElement;
        if (liveConcierge) liveConcierge.open(context);
        else {
          clear();
          say(config.live.unavailable);
          choice(config.live.preview, () => openPreview(context));
          if (!dialog.open) dialog.showModal();
        }
      } else if (config.mode !== 'integration' || shouldFallback) openPreview(context);
    },
    openPreview
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-walz-open]');
    if (!trigger) return;
    const context = {};
    if (trigger.dataset.walzIntent) context.intent = trigger.dataset.walzIntent;
    if (trigger.dataset.walzProduct) context.productHandle = trigger.dataset.walzProduct;
    document.querySelectorAll('.mobile-menu[open]').forEach(menu => { menu.open = false; });
    window.Walz.open(context);
  });
  dialog.querySelector('[data-walz-close]').addEventListener('click', () => dialog.close());
  dialog.querySelector('[data-walz-reset]').addEventListener('click', () => {
    if (liveConcierge?.isActive()) liveConcierge.reset();
    else { showWelcome(); focusContent(); }
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => { if (opener && opener.isConnected) opener.focus(); });
  document.querySelectorAll('[data-auto-submit]').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
  document.querySelectorAll('[data-variant-selector]').forEach(select => select.addEventListener('change', () => {
    document.querySelector('[data-product-price]').textContent = select.selectedOptions[0].dataset.price;
  }));
  const storageKey = 'walz-demo-selection-v2';
  let selection = [];
  let persistent = true;
  try {
    const saved = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (Array.isArray(saved)) selection = saved.filter(item => item && typeof item.id === 'string' && /^[a-z0-9-]+$/.test(item.handle) && typeof item.title === 'string' && typeof item.variant === 'string' && Number.isFinite(item.price) && item.price >= 0 && Number.isInteger(item.quantity) && item.quantity >= 1 && item.quantity <= 10).slice(0, 40);
  } catch { persistent = false; }
  const formatMoney = cents => new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency: config.currency || 'CHF' }).format(cents / 100);
  const updateCount = () => document.querySelectorAll('[data-selection-count]').forEach(node => { node.textContent = String(selection.reduce((sum, item) => sum + item.quantity, 0)); });
  function saveSelection() {
    try { localStorage.setItem(storageKey, JSON.stringify(selection)); } catch { persistent = false; }
    updateCount();
  }
  document.querySelectorAll('[data-demo-add]').forEach(button => button.addEventListener('click', () => {
    const form = button.closest('[data-demo-form]');
    const quantityInput = form.querySelector('[name="quantity"]');
    if (!quantityInput.reportValidity()) return;
    const selected = form.querySelector('[data-variant-selector]').selectedOptions[0];
    const quantity = Math.max(1, Math.min(10, Number(quantityInput.value) || 1));
    const existing = selection.find(item => item.id === selected.value);
    if (existing) existing.quantity = Math.min(10, existing.quantity + quantity);
    else selection.push({ id: selected.value, handle: form.dataset.productHandle, title: form.dataset.productTitle, defaultVariant: form.dataset.productDefaultVariant === 'true', variant: selected.textContent.trim(), price: Number(selected.dataset.priceCents), quantity });
    saveSelection();
    const status = form.querySelector('[data-selection-status]');
    status.replaceChildren(element('span', '', persistent ? strings.selected : strings.storageNote));
    const anchor = element('a', '', strings.viewSelection);
    anchor.href = config.cartUrl;
    status.append(document.createTextNode(' '), anchor);
  }));
  const cartRoot = document.querySelector('[data-demo-cart]');
  function renderSelection() {
    if (!cartRoot) return;
    cartRoot.replaceChildren();
    if (!selection.length) {
      const empty = element('div', 'empty-state');
      empty.append(element('span', 'empty-symbol', '△'), element('h2', '', strings.empty), element('p', '', strings.emptyDescription));
      const anchor = element('a', 'button button-pine', `${strings.continue} ↗`);
      anchor.href = cartRoot.dataset.catalogUrl;
      empty.append(anchor);
      cartRoot.append(empty);
      return;
    }
    const form = element('div', 'cart-form');
    const items = element('div', 'cart-items');
    selection.forEach(item => {
      const row = element('div', 'cart-item cart-item-local');
      const number = element('div', 'cart-item-marker', '△');
      number.setAttribute('aria-hidden', 'true');
      const info = element('div', 'cart-item-info');
      const title = element('h2');
      const anchor = element('a', '', item.title);
      anchor.href = `${root}/products/${item.handle}`;
      title.append(anchor);
      info.append(element('p', 'product-type', strings.demoItem), title, element('p', '', item.defaultVariant ? strings.standardVariant : item.variant));
      const remove = element('button', 'remove-link', strings.remove);
      remove.type = 'button';
      remove.setAttribute('aria-label', `${strings.remove} ${item.title}`);
      remove.addEventListener('click', () => {
        selection = selection.filter(candidate => candidate.id !== item.id);
        saveSelection();
        renderSelection();
        const next = cartRoot.querySelector('button, a');
        if (next) next.focus();
      });
      info.append(remove);
      const quantity = element('div', 'cart-quantity');
      const label = element('label', '', strings.quantity);
      label.htmlFor = `quantity-${item.id}`;
      const input = element('input');
      Object.assign(input, { id: label.htmlFor, type: 'number', min: '1', max: '10', value: String(item.quantity), inputMode: 'numeric' });
      input.setAttribute('aria-label', `${strings.quantity} ${item.title}`);
      input.addEventListener('change', () => {
        if (!input.reportValidity()) return;
        item.quantity = Math.max(1, Math.min(10, Number(input.value) || 1));
        saveSelection();
        row.querySelector('.cart-line-price').textContent = formatMoney(item.price * item.quantity);
        cartRoot.querySelector('[data-selection-total]').textContent = formatMoney(selection.reduce((sum, entry) => sum + entry.price * entry.quantity, 0));
      });
      quantity.append(label, input);
      row.append(number, info, quantity, element('p', 'cart-line-price', formatMoney(item.price * item.quantity)));
      items.append(row);
    });
    const summary = element('div', 'cart-summary');
    const total = element('div');
    const amount = element('p', '', formatMoney(selection.reduce((sum, item) => sum + item.price * item.quantity, 0)));
    amount.dataset.selectionTotal = '';
    total.append(element('h2', '', strings.total), amount);
    const ask = element('button', 'button button-pine', `${strings.askSelection} ✳`);
    ask.type = 'button';
    ask.dataset.walzOpen = '';
    const again = element('a', 'text-button', `${strings.continue} ↗`);
    again.href = cartRoot.dataset.catalogUrl;
    summary.append(total, element('p', '', strings.noCheckout), ask, again);
    if (!persistent) summary.append(element('p', '', strings.storageNote));
    form.append(items, summary);
    cartRoot.append(form);
  }
  window.addEventListener('storage', event => { if (event.key === storageKey) location.reload(); });
  updateCount();
  renderSelection();
})();
